<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconPresentationOn_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M14.75 19h-5.5l-.726 2.177a.625.625 0 0 0 .593.823h5.766a.625.625 0 0 0 .593-.823L14.75 19ZM18.9 4H5.1a2.6 2.6 0 0 0-2.6 2.6v8.8A2.6 2.6 0 0 0 5.1 18h13.8a2.6 2.6 0 0 0 2.6-2.6V6.6A2.6 2.6 0 0 0 18.9 4ZM20 15.4a1.1 1.1 0 0 1-1.1 1.1H5.1A1.1 1.1 0 0 1 4 15.4V6.6a1.1 1.1 0 0 1 1.1-1.1h13.8A1.1 1.1 0 0 1 20 6.6v8.8ZM5.5 15h13V7h-13v8Z"
    />
</svg>
